export default __webpack_public_path__ + "static/media/Help.ba6b070a.png";